import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const C = { primary:"#f97316", dark:"#ea580c", white:"#ffffff", bg:"#f2f2f7", text:"#1c1c1e", sub:"#6b7280", border:"#e5e7eb" };

function Section({ title, children }) {
  return (
    <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:14, border:`1px solid ${C.border}` }}>
      <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1rem", marginBottom:10, color:C.dark }}>{title}</div>
      <div style={{ fontSize:"0.85rem", color:C.sub, lineHeight:1.8 }}>{children}</div>
    </div>
  );
}

export default function RefundPolicy() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',system-ui,sans-serif", background:C.bg, minHeight:"100vh", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}`}</style>

      <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"14px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex" }}><ArrowLeft size={22} color={C.text}/></button>
        <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.15rem" }}>Refund & Cancellation Policy</div>
      </div>

      <div style={{ maxWidth:640, margin:"0 auto", padding:"24px 20px 48px" }}>

        <div style={{ background:`linear-gradient(135deg,${C.dark},${C.primary})`, borderRadius:16, padding:"20px 24px", marginBottom:20 }}>
          <div style={{ color:"#fff", fontWeight:800, fontSize:"1rem", marginBottom:4 }}>Refund & Cancellation — Quickry</div>
          <div style={{ color:"rgba(255,255,255,0.8)", fontSize:"0.78rem" }}>Last updated: January 2025 | Refunds processed within 5–7 business days</div>
        </div>

        <Section title="1. Cancellation by Customer">
          <strong style={{ color:C.text }}>Before Order Acceptance:</strong> You may cancel your order within <strong>2 minutes</strong> of placing it at no charge. Full refund will be issued for prepaid orders.<br/><br/>
          <strong style={{ color:C.text }}>After Order Acceptance:</strong> Once the restaurant or store has accepted and started preparing your order, cancellation is generally not possible. In exceptional cases, a partial refund may be issued at Quickry's discretion.<br/><br/>
          <strong style={{ color:C.text }}>How to Cancel:</strong> Go to My Orders → Select Order → Cancel Order (available within the cancellation window).
        </Section>

        <Section title="2. Cancellation by Quickry">
          Quickry reserves the right to cancel orders in cases of:<br/>
          • Restaurant/store unavailability or closure<br/>
          • Incorrect pricing or product information<br/>
          • Non-availability of delivery partner<br/>
          • Suspected fraudulent activity<br/>
          • Force majeure events (natural disasters, curfews, etc.)<br/><br/>
          In all such cases, a <strong style={{ color:C.text }}>full refund</strong> will be issued to the original payment method.
        </Section>

        <Section title="3. Refund Eligibility">
          Refunds are applicable in the following cases:<br/><br/>
          ✅ Order cancelled before preparation starts<br/>
          ✅ Order cancelled by Quickry or vendor<br/>
          ✅ Item(s) missing from the delivered order<br/>
          ✅ Wrong item(s) delivered<br/>
          ✅ Order not delivered but marked as delivered<br/>
          ✅ Significantly delayed delivery (more than 2x estimated time)<br/>
          ✅ Food quality issue reported with evidence within 1 hour of delivery<br/><br/>
          <strong style={{ color:"#ef4444" }}>❌ Refunds are NOT applicable for:</strong><br/>
          • Change of mind after delivery<br/>
          • Incorrect address provided by customer<br/>
          • Customer unavailable at delivery location<br/>
          • Partially consumed food items
        </Section>

        <Section title="4. Refund Process & Timeline">
          <strong style={{ color:C.text }}>For UPI/Online Payments:</strong> Refund credited to original payment source within <strong>5–7 business days</strong>.<br/><br/>
          <strong style={{ color:C.text }}>For Paytm Wallet:</strong> Refund credited within <strong>24 hours</strong>.<br/><br/>
          <strong style={{ color:C.text }}>For Credit/Debit Card:</strong> Refund processed within <strong>5–10 business days</strong> depending on your bank.<br/><br/>
          <strong style={{ color:C.text }}>For Cash on Delivery:</strong> COD orders are not eligible for monetary refunds. Store credit or re-delivery may be offered at Quickry's discretion.
        </Section>

        <Section title="5. How to Request a Refund">
          To request a refund:<br/>
          1. Contact us at <strong style={{ color:C.text }}>hello.quickry@gmail.com</strong><br/>
          2. Include your Order ID, registered phone number, and reason for refund<br/>
          3. Attach photos/evidence if applicable (for wrong/missing items)<br/>
          4. Submit request within <strong>24 hours</strong> of delivery<br/><br/>
          Our support team will review and respond within <strong>2 business days</strong>.
        </Section>

        <Section title="6. Partial Refunds">
          In cases where only some items are missing or incorrect, a partial refund corresponding to the affected items (including proportional delivery charges) will be issued.
        </Section>

        <Section title="7. Contact for Refund Queries">
          <strong style={{ color:C.text }}>Email:</strong> hello.quickry@gmail.com<br/>
          <strong style={{ color:C.text }}>Support Hours:</strong> 9:00 AM – 10:00 PM IST (Monday–Sunday)<br/>
          <strong style={{ color:C.text }}>Address:</strong> Quickry, Akola, Maharashtra — 444001, India
        </Section>

      </div>
    </div>
  );
}